import { RouterEffects } from "./router/router.effects";
import { ApplicationEffects } from "./application/application.effects";
import { SearchEffects as ContactSearchEffects } from "./contact-search/search.effects";

import { ContactEffects } from "./contact/contact.effects";
import { CompanyEffects } from "./company/company.effects";
import { UserProfileEffects } from "./user-profile/user-profile.effects";
import { TechStackEffects } from "./tect-stack/tech-stack.effects";
import { TechStackInsightsEffects } from "./insight/insight.effects";

export const EffectsConfiguration = [
    RouterEffects,
    ApplicationEffects,
    ContactSearchEffects,
    CompanyEffects,
    ContactEffects,
    UserProfileEffects,
    TechStackEffects,
    TechStackInsightsEffects,
];
